export default "__VITE_ASSET__liXETyqT__"